var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 47,
    viewBox: "0 0 67 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.24121V44.1821L23.5533 20.7453L0 2.24121Z",
    fill: "#0D1A2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5884 27.7056C34.269 27.9566 33.8846 28.0826 33.5001 28.0826C33.1157 28.0826 32.7312 27.9577 32.4119 27.7056L26.345 22.9395L2.49805 46.6679H64.5022L40.6553 22.9395L34.5884 27.7056Z",
    fill: "#0D1A2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67 44.1821V2.24121L43.4468 20.7453L67 44.1821Z",
    fill: "#0D1A2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1474 0H2.85229L33.4998 24.0787L64.1474 0Z",
    fill: "#0D1A2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9426581830725eec9bea1633213f2002.svg";
export { ForwardRef as ReactComponent };